import { useCallback } from "react";

import { OfferCommandPlugin } from "./OfferCommandPlugin";
import { useMessageDraftStore } from "../../../editor/messageDraftStoreFactory";
import type { TextComposerOfferSlice } from "../offerExtension";

/**
 * Store-coupled wrapper around `OfferCommandPlugin`: mirrors offer removal into
 * the message-draft store. The command/keyboard logic lives in
 * `OfferCommandPlugin` so `InlineLexicalInput` can reuse it without the store.
 */
export function OfferPlugin() {
  const setOffer = useMessageDraftStore(
    (s) =>
      s.actions.setOffer as (offer: TextComposerOfferSlice | undefined) => void,
  );

  const handleOfferRemoved = useCallback(() => setOffer(undefined), [setOffer]);

  return <OfferCommandPlugin onOfferRemoved={handleOfferRemoved} />;
}
